/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InventoryIndexPathParams, InventoryIndexResponse } from '../types/InventoryIndex'

/**
 * GET /:organisation/inventory
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::index
 */
export async function inventoryIndex(
	organisation: InventoryIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventoryIndexResponse>> {
	return axiosInstance.get(`/${organisation}/inventory`, config)
}
